/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Text, BoxProps } from '@chakra-ui/react';
import { InfoIcon } from './InfoIcon';

interface Props extends BoxProps {
  message: string;
}

export const WarningBox: React.FC<Props> = ({ message, ...rest }) => (
  <Box
    display="flex"
    alignItems="center"
    background="warningBg"
    p={4}
    borderRadius={8}
    fontSize={12}
    gridGap={18}
    {...rest}
  >
    <InfoIcon warning={1} />
    <Text flex={1} textStyle="warning">
      {message}
    </Text>
  </Box>
);
